'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseCard = require('@bibliocommons/base-card');

require('../styles/ListCard.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ListCard(_ref) {
  var listId = _ref.listId,
      title = _ref.title,
      type = _ref.type,
      description = _ref.description,
      imageSrc = _ref.imageSrc,
      creator = _ref.creator,
      cardHeadingTag = _ref.cardHeadingTag;

  var exitUrl = '/list/share/' + creator.id + '/' + listId;
  var creatorUrl = '/user_profile/' + creator.id;
  var cardProps = {
    title: title,
    description: description,
    imageSrc: imageSrc,
    imageAlt: '',
    rectangle: true,
    border: true,
    cardHeadingTag: cardHeadingTag,
    creatorName: creator.name,
    creatorUrl: creatorUrl,
    exitUrl: exitUrl,
    presentational: false,
    tags: [{ label: type }]
  };

  return _react2.default.createElement(_baseCard.GenericCard, cardProps);
}

ListCard.propTypes = {
  listId: _react.PropTypes.string.isRequired,
  title: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string.isRequired,
  description: _react.PropTypes.string,
  cardHeadingTag: _react.PropTypes.string,
  imageSrc: _react.PropTypes.string.isRequired,
  creator: _react.PropTypes.shape({ id: _react.PropTypes.string, name: _react.PropTypes.string }).isRequired
};

ListCard.defaultProps = {
  cardHeadingTag: 'h3',
  imageSrc: 'http://placekitten.net/g/200/200'
};

exports.default = ListCard;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/card/list-card/lib/components/ListCard.component.js
// module id = 987
// module chunks = 5